import { render } from "./GhostBtn.vue?vue&type=template&id=3d044658&scoped=true"
import script from "./GhostBtn.vue?vue&type=script&lang=js"
export * from "./GhostBtn.vue?vue&type=script&lang=js"

import "./GhostBtn.vue?vue&type=style&index=0&id=3d044658&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d044658"]])

export default __exports__